import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { RandomIcon } from '@karma/components/icons';
import { Button, Typography } from '@karma/components';
import { PATHS } from 'consts/paths';
import { Container } from './EmptyState.style';

const EmptyState = ({ title, withExploreButton, resetState }) => {
  const { t } = useTranslation();
  const clickHandler = useCallback(() => resetState && resetState(), [resetState]);

  return (
    <Container>
      <RandomIcon width={108} height={108} />
      <Typography variant="h3" tMargin={25} bMargin={8}>
        {t(title)}
      </Typography>
      {withExploreButton ? (
        <Button as={Link} to={PATHS.RETAILERS} size="medium" onClick={clickHandler}>
          {t('app:exploreStores')}
        </Button>
      ) : null}
    </Container>
  );
};

export default EmptyState;
